export default __webpack_public_path__ + "static/Michael-080742accdbb7252c0db090601f64cfa.jpeg";